import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTable } from 'react-table';
import { TABLET_WIDTH } from '~~elements/Const';
import Button from '~~elements/Button';
import UTRMultilingual from '../Multilingual';
import moment from 'moment';

export const StyledTableArea = styled.div`
  display: block;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  font-size: 0.9rem;

  table {
    width: 100%;
    border-spacing: 0;

    tbody > tr {
      :hover {
        background: #b7e9fb;
      }
      border-bottom: 1px solid #eee;
    }

    th {
      white-space: nowrap;
    }

    th,
    td {
      text-align: left;
      margin: 0;
      padding: 0.5rem;
      border-right: 0px;
      :last-child {
        border-right: 0px;
      }

      width: 1%;
      &.collapse {
        width: 0.0000000001%;
      }
    }

    .nowrap {
      white-space: nowrap;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    width: 100%;
  }
`;

const ListTeamsInRegistries = ({ list, handleTeamInRegistry }) => {
  const columns = useMemo(
    () => [
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.TOURNAMENT`),
        accessor: (teamInRegistry) => teamInRegistry.season.title,
      },
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.TEAM`),
        accessor: 'name',
      },
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.HISTORY_CONNECTION`),
        accessor: (teamInRegistry) =>
          !teamInRegistry.connected_team ? UTRMultilingual(`COMMON.NONE`) : teamInRegistry.connected_team.name,
      },
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.STATUS`),
        accessor: (teamInRegistry) => UTRMultilingual(`CUSTOM.STATUS.${teamInRegistry.status}`),
      },
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.UPDATED_AT`),
        accessor: (teamInRegistry) => moment(teamInRegistry.last_updated_at).format('YYYY/MM/DD HH:mm'),
      },
      {
        Header: UTRMultilingual(`CUSTOM.TABLE.ACTION.WORDING`),
        Cell: ({ row: { original: teamInRegistry } }) => {
          return (
            <Button onClick={handleTeamInRegistry(teamInRegistry)} width="auto" color="blue" mini nowrap>
              {UTRMultilingual(`CUSTOM.TABLE.ACTION.MANAGE`)}
            </Button>
          );
        },
      },
    ],
    [handleTeamInRegistry],
  );

  const { getTableProps, getTableBodyProps, rows, headerGroups, prepareRow } = useTable({
    columns,
    data: list,
  });

  return (
    <StyledTableArea>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps({
                        className: cell.column.className,
                      })}
                      style={{ width: cell.column.width }}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledTableArea>
  );
};

export default ListTeamsInRegistries;
